import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setUser } from './redux/authSlice'
import { getCurrentTherapist } from './redux/therapistSlice'
import { getCurrentUser } from './redux/userSlice'
import { getUserRequests, getTherapistRequests } from './redux/requestSlice'
import AppRoute from './AppRoute'
import NotificationSocket from './components/Chat/NotificationSocket'

function App() {
  const dispatch = useDispatch();
  const authToken = useSelector((state) => state.auth?.token);
  const therapistLoginSuccess = useSelector((state) => state.therapist?.loginSuccess);
  const hasToken = Boolean(localStorage.getItem("token") || authToken);

  useEffect(() => {
    const token = localStorage.getItem("token") || authToken;
    const user = localStorage.getItem("user");
    const userType = localStorage.getItem("userType");

    if (token) {
      if (user) {
        try {
          const parsedUser = JSON.parse(user);
          dispatch(setUser({ token, user: parsedUser }));
        } catch (error) {
          localStorage.removeItem("user");
        }
      }

      // Fetch full profile so NotificationSocket can join chat rooms on any page
      if (userType === "therapist") {
        dispatch(getCurrentTherapist());
        dispatch(getTherapistRequests());
      } else if (userType === "user") {
        dispatch(getCurrentUser());
        dispatch(getUserRequests());
      }
    }
  }, [dispatch, authToken, therapistLoginSuccess]);

  return (
    <div className="App">
      <ToastContainer position="top-right" limit={1} autoClose="1000" />
      {hasToken && <NotificationSocket />}
      <AppRoute />
    </div>
  )
}

export default App
